import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100 perks_it">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Our IT Staff Augmentation Process – Helpful & Hassle-Free</h2>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content ">
                <h4>
                  Needs
                  <br />
                  Assessment
                </h4>
                <p>
                  We start by understanding your project requirements, technical
                  needs, and team dynamics. This allows us to identify the exact
                  skills and expertise you need.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Talent
                  <br />
                  Sourcing
                </h4>
                <p>
                  Leveraging our extensive network, we source the best-fit
                  candidates with the necessary skills and experience. Our
                  rigorous screening process ensures that you get top-tier
                  professionals who can hit the ground running.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Onboarding & <br />
                  Integration
                </h4>
                <p>
                  Once the right candidates are selected, we facilitate a smooth
                  onboarding process. Our professionals integrate into your
                  team, familiarizing with your projects, tools, and
                  methodologies to ensure seamless collaboration.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Ongoing Support & <br />
                  Management
                </h4>
                <p>
                  We provide continuous support and management to ensure the
                  augmented staff meet your expectations. Regular check-ins and
                  performance evaluations help maintain high productivity and
                  quality.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
